import TextButton from 'LuxKit/Button/TextButton'
import type { OfferComparisonOption } from 'hooks/Offers/useOfferComparison'
import useOfferUrl from 'hooks/Offers/useOfferUrl'
import { FormattedMessage } from 'react-intl'

interface Props {
  option: OfferComparisonOption
}

function ViewOfferButton({ option }: Props) {
  const offerUrl = useOfferUrl(option.offer, {
    filters: option.selection.params?.filters,
    searchId: option.selection.params?.searchId,
    offerLinkIncludesFilters: true,
  })

  return (
    <TextButton fit="full-width" kind="primary" to={offerUrl} target="_blank">
      <FormattedMessage
        id="stfrrAsZAllwiTsABrUZ"
        defaultMessage="View offer"
        description="Button to view the full offer details in the offer comparison modal"
      />
    </TextButton>
  )
}

export default ViewOfferButton
